import { createContext } from 'react'

export const DocFlowSendingContext = createContext()
